export default {
    mixins: [
    ],
    data() {
        return {
            idPanel: null,
        }
    },
    computed: {
        acl(){
            return this.idPanel && this.moduleCode ? this.$store.getters.getAcl(this.moduleCode, this.idPanel) : {};
        },
        url(){
            return this.idPanel && this.moduleCode ? this.$store.getters.getUrl(this.moduleCode, this.idPanel) : {};
        },
        tool(){
            return this.idPanel && this.moduleCode ? this.$store.getters.getTool(this.moduleCode, this.idPanel) : {};
        },
        title(){
            return this.tool && this.tool.title ? this.$t(this.tool.title)  : null;
        },
        getPanel(){
            return this.idPanel && this.moduleCode ? this.$store.getters.getPanel(this.moduleCode, this.idPanel) : {};
        },
        panel(){
            return this.getPanel;
        },
        isPanelActive(){
            return this.idPanel && this.moduleCode ? this.$store.getters.isPanelActive(this.moduleCode, this.idPanel): false;
        },
        isPanelVisible(){
            return this.idPanel && this.moduleCode ? this.$store.getters.isPanelVisible(this.moduleCode, this.idPanel): false;
        },
    },
    methods: {
        openPanel(idPanel=null){
            return this.$store.dispatch(`${this.moduleCode}/openPanel`, idPanel ? idPanel : this.idPanel);
        },
        closePanel(idPanel=null){
            return this.$store.dispatch(`${this.moduleCode}/closePanel`, idPanel ? idPanel : this.idPanel);
        },
    },
};
